import { VComparable } from "./valuation-comparable.model";

export interface HamptonComparable { 
  id: number,
  refNum: string,

  buildingName: string

  size: number,
  price: number,

  sourceDate: Date,
  sourceType: string
}

export function mapToHamptonComparable(comparable: VComparable): HamptonComparable {
  return { 
    id: comparable.id,
    refNum: comparable.refNum,
    buildingName: getBuildingName(comparable),
    size: getSize(comparable),
    price: getConsideration(comparable),
    sourceDate: getDate(comparable),
    sourceType: getSourceType(comparable)
  }
}

function getBuildingName(comparable: VComparable) {
  if (
    comparable.propertySubType != 'House'
    && comparable.propertySubType != 'Warehouse'
    && comparable.propertySubType != 'Retail Building'
    && comparable.propertySubType != 'Land'
    && comparable.propertySubType != 'Special Purpose'
  ) {
    return comparable.building.name
  }
  return "N/A"
}

function getSize(comparable: VComparable) {
  const sizes = comparable.sizes
  if (sizes.length == 0) return 0
  return sizes[0].size
}

function getConsideration(comparable: VComparable) {
  if (comparable.displayConsiderations.length == 0) return 0;
  const consideration = comparable.displayConsiderations[0]
  return consideration.value
}

function getDate(comparable: VComparable) {
  if (comparable.displayConsiderations.length == 0) return null;
  const consideration = comparable.displayConsiderations[0]
  if (!consideration.source) return null;
  const source = consideration.source
  if (source.sourceType === 'Advertised') return source.informationDate
  return source.transactionDate
}

function getSourceType(comparable: VComparable) {
  if (comparable.displayConsiderations.length == 0) return null;
  const consideration = comparable.displayConsiderations[0]
  if (!consideration.source) return null;
  const source = consideration.source
  return source.sourceTypeName
}